<div *ngFor="let section of tab.sections | dsLibCheckRights: rights" class="padding-bottom relative">
  <a
    *ngIf="section.title && !section.external; else externalLink"
    (click)="onSectionClick(section)"
    [routerLink]="section.link | dsLibMainMenuRouterLink: getArgs(section)"
    routerLinkActive="active-link"
  >
    <mat-list-item
      [class.expand]="isExpanded"
      [ngStyle]="{ 'pointer-events': section.links?.length > 0 && isExpanded ? 'none' : 'auto' }"
    >
      <mat-icon mat-list-icon>{{ section.icon }}</mat-icon>
      <ng-container *ngIf="isExpanded">
        <h3 mat-subheader [ngStyle]="{ 'font-size': fontSize }">{{ section.title | translate }}</h3>
      </ng-container>
    </mat-list-item>
  </a>

  <!-- Template if it's an external link -->
  <ng-template #externalLink>
    <a *ngIf="section.title && section.link" href="{{ section.link.url }}" target="_blank">
      <mat-list-item
        [class.expand]="isExpanded"
        [ngStyle]="{ 'pointer-events': section.links?.length > 0 && isExpanded ? 'none' : 'auto' }"
      >
        <mat-icon mat-list-icon>{{ section.icon }}</mat-icon>
        <ng-container *ngIf="isExpanded">
          <h3 mat-subheader [ngStyle]="{ 'font-size': fontSize }">{{ section.title | translate }}</h3>
        </ng-container>
      </mat-list-item>
    </a>
  </ng-template>

  <!-- List of section links -->
  <ng-container *ngIf="isExpanded">
    <a
      mat-list-item
      *ngFor="let link of section.links | dsLibCheckRights: rights"
      [routerLink]="link | dsLibMainMenuRouterLink: { id: tab.selectedItem?.id, sectionId: section?.sectionId }"
      routerLinkActive="active-link"
      [class.disabled]="link.disabled"
    >
      <mat-list-item [class.expand]="isExpanded">
        <h3 mat-subheader class="link-expanded">
          {{ link.title | translate }}
        </h3>
      </mat-list-item>
    </a>
  </ng-container>
</div>
